export default class RequestTimeoutError extends Error {
    constructor(url, requestInit, timeout) {
        super(`Request timeout: ${url} (${timeout}ms)`);
        this.name = 'RequestTimeoutError';
        this.url = url;
        this.requestInit = requestInit;
        this.timeout = timeout;
    }
}
